import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "trTrim",
})
export class TrTrimPipe implements PipeTransform {
  public transform(item: string): string {
    if (!item) {
      return ""
    }

    return item.trim()
  }
}
